import React, { useEffect, useState } from 'react';
import { getDashboardVersionHistoryAPI, updateDashboardVersionHistoryAPI } from '../../../../service/ai-model.service';
import constant, { DashboardViewType } from '../../../../helper/constant';
import { useAppContext } from '../../../../context/app.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../../../../helper/helper';


const DashboardHistory = ({ type }) => {

    const [versionList, setVersionList] = useState([]);
    const [selectedVersion, setSelectedVersion] = useState('');
    const { updateBusinessVersion } = useAppContext();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const org = params.get('org');
        getDashboardVersionHistoryAPI({ org, type })
            .then(data => {
                setVersionList(data.versions);
                const defaultVersion = data.versions.find(i => i.MASTER === true);
                setSelectedVersion(defaultVersion ? defaultVersion.versionId : data.versions[0].versionId);
            })
            .catch(e => e);
    }, []);

    useEffect(() => {
        if (selectedVersion) {
            updateBusinessVersion(selectedVersion);
        }
    }, [selectedVersion]);

    const renderProductSelectBox = () => {
        return (
            <div className="form-group mb-0">
                <select className="form-control version-select"
                    id="version-select"
                    style={{ borderRadius: '50px', width: '250px', border: '1px solid #217ce8', padding: 7, backgroundColor: '#f1f1f1' }}
                    value={selectedVersion}
                    onChange={(e) => setSelectedVersion(e.target.value)}>
                    {versionList.map((i, index) => <option value={i.versionId} key={`version-index-${index}`}>
                        <>{formatDate(i.updatedAt, constant.displayFormat)} {i.MASTER && <>*</>}</>
                    </option>)}
                </select>
            </div>
        )
    }

    const onPressedMarkAsDefault = () => {
        const params = new URLSearchParams(window.location.search)
        const org = params.get('org');
        const type = DashboardViewType.DASHBOARDS;
        updateDashboardVersionHistoryAPI({ org, type, versionId: selectedVersion })
            .then(r => {
                const updatedList = versionList.map(i => {
                    if (i.versionId === selectedVersion) {
                        return { ...i, MASTER: true }
                    }
                    return { ...i, MASTER: false }
                });
                setVersionList(updatedList);
            })
            .catch(e => e);
    }

    const render = () => {
        if (versionList.length === 0) return null;
        const isMaster = versionList.find(i => i.versionId === selectedVersion && i.MASTER);
        return (
            <div className='d-flex align-items-center gap-1'>
                {renderProductSelectBox()}
                {!isMaster && <button className='btn btn-primary ms-3' onClick={() => onPressedMarkAsDefault()}>Mark as Default</button>}
            </div>
        )
    }
    return render();
}

export default DashboardHistory